import {
	mapGetters
} from 'vuex';

export default {
	name: 'inbox-sidebar-menu',
	data: () => ({}),
	computed: {
		...mapGetters([])
	},
	mounted() {

		// TODO - get unread messages from `top.`

	}
};



// WEBPACK FOOTER //
// ./sources/domains/inbox/sidebar-menu/index.js